<div
  *ngIf="showOverlay"
  class="overlay-container flex flex-column justify-content-center"
  [style.background-image]="'url(' + backgroundUrl + ')'"
>
  <div
    style="background-color: rgba(0, 0, 0, 0.5); position: fixed; width: 100%; height: 100%"
  ></div>
  <div class="flex-grow-1 flex flex-column ontop">
    <img class="imgWidth" style="margin-top: 30px" [src]="logoLoginUrl" />
    <h2>{{ 'downloadOverlay.title_download_app' | translate }}</h2>
    <p>{{ 'downloadOverlay.text_download_app' | translate }}</p>
    <div class="flex justify-content-center">
      <a href="{{ themeConfig?.downlaodAPPUrl }}" target="_blank">
        <button class="btn btn-success" style="margin: 15px">
          {{ 'downloadOverlay.download_app' | translate }}
        </button>
      </a>
    </div>
    <div class="flex justify-content-center" style="margin-top: 10px">
      <a class="text-white" (click)="showMobileClosed()">{{
        'downloadOverlay.no_thanks' | translate
      }}</a>
    </div>
  </div>
  <img class="flex-shrink-1" [src]="mobileScreeAPP" />
</div>
